import { Trash2, Layers } from "lucide-react";
import { toThumbUrl } from "@dm-online/shared";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

// デッキ一覧の1行（プレゼンテーション専用）。DecksPage とスタイルガイドで共用する。
export default function DeckListItem({
  name,
  formatLabel,
  keyCardImage,
  keyCardName,
  onOpen,
  onDelete,
}: {
  name: string;
  formatLabel: string;
  keyCardImage?: string | null;
  keyCardName?: string;
  onOpen: () => void;
  onDelete: () => void;
}) {
  return (
    <div
      onClick={onOpen}
      className="group flex cursor-pointer overflow-hidden rounded-md border border-border bg-card text-card-foreground"
    >
      {/* キーカードのサムネイル（縦横比 63:88・トリミングなしで枠に収める） */}
      <div className="relative w-20 shrink-0 overflow-hidden bg-muted" style={{ aspectRatio: "63 / 88" }}>
        {keyCardImage ? (
          <img
            src={toThumbUrl(keyCardImage)}
            alt={keyCardName ?? ""}
            loading="lazy"
            className="size-full object-cover"
          />
        ) : (
          <div className="grid size-full place-items-center text-muted-foreground">
            <Layers className="size-4" />
          </div>
        )}
      </div>

      {/* 本文 */}
      <div className="flex min-w-0 flex-1 flex-col gap-2 p-2">
        <Typography variant="title" as="span" className="truncate">{name}</Typography>
        <Badge variant="secondary">{formatLabel}</Badge>

        {/* フッター：削除ボタン */}
        <div className="mt-auto flex justify-end" onClick={(e) => e.stopPropagation()}>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDelete}
            className="gap-1.5 text-muted-foreground hover:text-destructive"
          >
            <Trash2 />
            削除
          </Button>
        </div>
      </div>
    </div>
  );
}
